// extracted by mini-css-extract-plugin
export default {"root":"DZJAgO1_","icon":"DNxf1fb1","interactive":"GU6t4snd","thumbnail":"l7Jv2Ysl","info":"cjX8maBi","title":"nfp5rpIc","description":"qBj00Hsz"};